import css from "standard/css";

const style = css`
  .onboarding {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-xs);
  }

  .onboarding__ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing_inset-xs);
    list-style: none;
  }

  .onboarding__label {
    align-items: start;
    border: var(--border-width-hairline) solid var(--color-master-light);
    border-radius: var(--border-radius-sm);
    cursor: pointer;
    display: flex;
    gap: var(--spacing_inset-xs);
    padding: var(--spacing_inset-xs);
    width: 100%;

    input {
      margin-top: var(--spacing-nano);
    }

    input:checked {
      accent-color: #FB601D;
    }

    span {
      color: var(--color-master-darker);
      font-family: var(--font-family-base);
      font-weight: var(--font-weight-medium);
      font-size: var(--font-size-sm);
      line-height: var(--line-height-lg);
    }

    strong {
      color: var(--color-master);
      font-family: var(--font-family-base);
      font-weight: var(--font-weight-regular);
      font-size: var(--font-size-xxs);
      line-height: var(--line-height-lg);
    }
  }

  .onboarding__label:focus-within {
    border-color: #FB601D;
  }

  .onboarding__button {
    align-items: center;
    background-color: #3481b2;
    border: none;
    border-bottom: 2px solid #5c9ac1;
    border-radius: var(--border-radius-sm);
    box-shadow: 0 10px 0 #2a668c;
    text-shadow: 0 2px 0 rgba(0, 0, 0, 0.2);
    color: var(--color-pure-white);
    cursor: pointer;
    display: flex;
    font-family: var(--font-family-highlight);
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-bold);
    padding: var(--spacing_inset-nano) var(--spacing_inset-xs);
    justify-content: center;
  }

  .onboarding__button:active {
    box-shadow: none;
    transform: translateY(5px);
  }

  .onboarding__supporting {
    align-items: center;
    color: var(--color-danger);
    display: none;
    font-family: var(--font-family-base);
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-medium);
    gap: var(--spacing_inset-quarck);
    line-height: var(--line-height-md);

    svg {
      aspect-ratio: 1 / 1;
      height: 18x;
      width: 18px;
    }
  }

  .onboarding__supporting[invalid="true"] {
    display: flex;
  }
`;

export default style;
